import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export class ModalRoot extends Vue {
  @Prop() loading: boolean;
  @Prop({ default: true }) padded: boolean;

  scrolledDown = false;

  hasHeader(): boolean {
    return !!this.$slots.header;
  }

  hasFooter(): boolean {
    return !!this.$slots.footer;
  }

  showFooter(): boolean {
    return !this.loading && this.hasFooter();
  }

  get scrollClass(): string {
    return this.scrolledDown ? 'scrolled-down' : 'scrolled-top';
  }

  handleScrollEvent(event: any) {
    const modalBody: Element = event.currentTarget;
    if (!this.scrolledDown && !!modalBody.scrollTop) {
      this.scrolledDown = true;
    } else if (this.scrolledDown && !modalBody.scrollTop) {
      this.scrolledDown = false;
    }
  }
}
